import ActionsForm from '@/shared/mixins/actionsForm'
import ModalAjuizamento from './modal/AjuizamentoModal.vue'

import TextTruncate from './TextTruncate.vue'

export default {
  name: 'CrmAjuizamento',
  mixins: [ActionsForm],
  props: {
    ajuizamentos: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      data: null,
      form: null,
      ajuizamento: null
    }
  },
  components: {
    ModalAjuizamento,
    TextTruncate
  },
  methods: {
    onLoad () {
    },
    onReload () {
      this.$emit('Reload')
    },
    formatDate (date) {
      if (!date) {
        return ''
      }

      const dateObj = new Date(date)
      dateObj.setDate(dateObj.getDate() + 1)

      return dateObj.toLocaleString('pt-BR', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      })
    },
    editAjuizamento (ajuizamento) {
      this.ajuizamento = ajuizamento
      this.$refs.ModalAjuizamento.showModal()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/ajuizamento/ajuizamento.js